import { render, staticRenderFns } from "./ModalChatGroup.vue?vue&type=template&id=472b8a4c&"
import script from "./ModalChatGroup.vue?vue&type=script&lang=js&"
export * from "./ModalChatGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports